// RegistryViewGroupRow.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './RegistryViewGroups.css';

// Icons
import Icon from 'svg/Icon';

/**
 * RegistryViewGroupRow
 *
 * @returns {ReactNode}
 */
const RegistryViewGroupRow = React.memo(({
  group,
  isDragging = false,
  isDropTarget = false,
  onClick,
  onDelete,
  onDragEnd,
  onDragOver,
  onDragStart,
  onDrop,
  onSettingsClick,
}) => {
  const { theme } = useTheme();
  const label = String(group?.label || '').trim() || 'Untitled group';
  const note = String(group?.description || '').trim();

  return (
    <div
      className={`registry-view-group-row${isDragging ? ' is-dragging' : ''}`}
      style={{
        backgroundColor: isDropTarget ? theme.backgroundHover : theme.panel,
        borderColor: isDropTarget ? theme.foregroundMuted : theme.backgroundHover,
      }}
      draggable
      title={label}
      onClick={onClick}
      onDragEnd={onDragEnd}
      onDragOver={(event) => {
        event.preventDefault();
        onDragOver?.();
      }}
      onDragStart={onDragStart}
      onDrop={(event) => {
        event.preventDefault();
        onDrop?.();
      }}
    >
      <div className="registry-view-group-row-main">
        <div className="registry-view-group-row-icon">
          <Icon
            iconKey="folder"
            width={18}
            height={18}
            color={theme.foregroundMuted}
          />
        </div>
        <div className="registry-view-group-row-copy">
          <div className="registry-view-group-row-label">{label}</div>
          {note ? (
            <div
              className="registry-view-group-row-note"
              style={{ color: theme.foregroundMuted }}
            >
              {note}
            </div>
          ) : null}
        </div>
      </div>
      <div className="registry-view-group-row-actions">
        <button
          className="registry-view-group-row-action"
          type="button"
          title="Edit"
          onClick={(event) => {
            event.stopPropagation();
            onSettingsClick?.();
          }}
        >
          <Icon iconKey="settings" width={18} height={18} color={theme.foregroundMuted} />
        </button>
        <button
          className="registry-view-group-row-action"
          type="button"
          title="Delete"
          onClick={(event) => {
            event.stopPropagation();
            onDelete?.();
          }}
        >
          <Icon iconKey="delete" width={18} height={18} color={theme.foregroundMuted} />
        </button>
      </div>
    </div>
  );
});

RegistryViewGroupRow.displayName = 'RegistryViewGroupRow';

export default RegistryViewGroupRow;
